<button
  (click)="onClick()"
  translate
  data-automation-id="borrow-n-deliver-btn"
  class="app-button bnd-button">
  borrowNDeliver
</button>
